"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var es6_promise_1 = require("es6-promise");
es6_promise_1.polyfill();
var axios_1 = require("axios");
var Vapi = /** @class */ (function () {
    function Vapi(options) {
        this.config = {};
        this.baseURL = options.baseURL;
        this.token = options.token;
        this.Http = axios_1.default.create({
            baseURL: options.baseURL,
            headers: {
                Authorization: 'Bearer ' + options.token,
            },
        });
        return this;
    }
    Vapi.prototype.updateService = function (options) {
        if (options.token) {
            this.token = options.token;
        }
        var headers = {
            Authorization: 'Bearer ' + this.token,
        };
        if (options.xTenantID) {
            headers['X-Tenant-ID'] = options.xTenantID;
        }
        this.Http = axios_1.default.create({
            baseURL: this.baseURL,
            headers: headers,
        });
        return this;
    };
    Vapi.prototype.getUserPermissions = function (data) {
        var promise;
        promise = this.Http.get('actions-by-user', { params: data });
        return promise;
    };
    Vapi.prototype.getAllThemes = function () {
        var promise;
        promise = this.Http.get('themes');
        return promise;
    };
    Vapi.prototype.getCryptext = function () {
        var promise;
        promise = this.Http.get('cryptext');
        return promise;
    };
    Vapi.prototype.getAllUsers = function () {
        var promise;
        promise = this.Http.get('contributors');
        return promise;
    };
    Vapi.prototype.addPhoto = function (data) {
        var formData = new FormData();
        var photoTitle = data.photoTitle, description = data.description, contributor = data.contributor, themesIds = data.themesIds, fileName = data.fileName, fileType = data.fileType, photoKeywords = data.photoKeywords;
        formData.append("photoTitle", photoTitle);
        formData.append("description", description);
        formData.append("contributor", contributor);
        var ids = {};
        if (themesIds) {
            themesIds.map(function (id) {
                ids[id.toString()] = id;
            });
        }
        var themes = JSON.stringify(ids);
        formData.append("themes", themes);
        formData.append("fileName", fileName);
        formData.append("fileType", fileType);
        formData.append("keyWords", photoKeywords);
        var promise;
        promise = this.Http.post('photo', formData);
        return promise;
    };
    Vapi.prototype.editPhoto = function (data) {
        var formData = new FormData();
        var photoTitle = data.photoTitle, description = data.description, contributor = data.contributor, themesIds = data.themesIds, fileName = data.fileName, fileType = data.fileType, photoId = data.photoId, photoKeywords = data.photoKeywords;
        formData.append("title", photoTitle);
        formData.append("description", description);
        formData.append("contributor", contributor);
        formData.append("keyWords", photoKeywords);
        var ids = {};
        if (themesIds) {
            themesIds.map(function (id) {
                ids[id.toString()] = id;
            });
        }
        var themes = JSON.stringify(ids);
        formData.append("themes", themes);
        formData.append("fileName", fileName);
        formData.append("fileType", fileType);
        var promise;
        promise = this.Http.put('photos/' + photoId, formData);
        return promise;
    };
    Vapi.prototype.deletePhoto = function (ids) {
        var promise;
        promise = this.Http.delete('deletePhotos', { params: { photosIds: ids } });
        return promise;
    };
    Vapi.prototype.getPhotoByHash = function (hash) {
        var promise;
        promise = this.Http.get('photoByHash', { params: { photoHash: hash } });
        return promise;
    };
    Vapi.prototype.getAllPhotos = function (data) {
        var promise;
        promise = this.Http.get('photos', { params: data });
        return promise;
    };
    return Vapi;
}());
exports.Vapi = Vapi;
exports.default = Vapi;



//////////////////
// WEBPACK FOOTER
// ./~/vuex-photoprism-service-api/dist/index.js
// module id = 856
// module chunks = 0 3